export const UPDATE_SHORTLIST_STONE_COUNT = "UPDATE_SHORTLIST_STONE_COUNT";
export const ADD_SHORTLIST_STONE = "ADD_SHORTLIST_STONE";
export const SET_CC_MODE_SETTING = "SET_CC_MODE_SETTING";
export const SET_CC_MODE_PARAMETER_PERMISSIONS = "SET_CC_MODE_PARAMETER_PERMISSIONS";
export const SET_CC_MODE_SETTING_ALLOW_CURRENCY_CHANGE = "SET_CC_MODE_SETTING_ALLOW_CURRENCY_CHANGE";
export const SET_CC_MODE_CONSUMER_SESSION = "SET_CC_MODE_CONSUMER_SESSION";
export const SET_CC_MODE_PLAN_FEATURES = "SET_CC_MODE_PLAN_FEATURES";

export const updateShortlistStoneCount = ({ shortListedStoneCount }) => {
  return {
    type: UPDATE_SHORTLIST_STONE_COUNT,
    payload: {
      shortListedStoneCount,
    },
  };
};

export const addShortlistStone = (shortListedStone) => {
  return {
    type: ADD_SHORTLIST_STONE,
    payload: shortListedStone,
  };
};

export const setCcModeSetting = ({
  hideCertificateNumber,
  hideEstimatedShippingDays,
  hidePrice,
  displayName,
  displaybuybtn,
  displayNatural,
  displayLab,
  startSession,
  cartNotification,
  isBuyRequest,
  enableShare,
  shareViaText,
  shareViaWhatsapp,
  shareViaEmail
}) => {
  return {
    type: SET_CC_MODE_SETTING,
    payload: {
      hideCertificateNumber,
      hideEstimatedShippingDays,
      hidePrice,
      displayName,
      displaybuybtn,
      displayNatural,
      displayLab,
      startSession,
      cartNotification,
      isBuyRequest,
      enableShare,
      shareViaText,
      shareViaWhatsapp,
      shareViaEmail
    },
  };
};

export const setCcModeSettingAllowCurrencyChange = (
  allowCurrencyChange
) => {
  return {
    type: SET_CC_MODE_SETTING_ALLOW_CURRENCY_CHANGE,
    payload: {
      allowCurrencyChange
    },
  };
};

export const setCcModeParameterPermissions = ({
  brand,
  milky,
  shade,
  origin,
  eyeClean,
  treatment,
  keyToSymbol,
  secondary
}) => {
  return {
    type: SET_CC_MODE_PARAMETER_PERMISSIONS,
    payload: {
      brand,
      milky,
      shade,
      origin,
      eyeClean,
      treatment,
      keyToSymbol,
      secondary
    },
  };
};

export const setCcmodeConsumerSession = (consumerSessionDetails) => {
  return {
    type: SET_CC_MODE_CONSUMER_SESSION,
    payload: {
      consumerSessionDetails
    }
  }
}

export const setCcmodePlanFeatures = (planFeatures) => {
  return {
    type: SET_CC_MODE_PLAN_FEATURES,
    payload: {
      planFeatures
    }
  }
}